<template>
  <div class="h5-container">
    <van-nav-bar class="top-bar" title="首页"></van-nav-bar>
    <div class="container-item">
    <!-- 原有用户信息卡片 -->
    <van-card shadow="never" class="user-card">
      <template #desc>
        <div class="user-header">
          <van-image round class="user-header-img"
                     :src="avatarPic"
          >
          </van-image>
          <div class="user-info">
            <h3>{{userInfo.nickName}}</h3>
            <h3>{{ userInfo.userName ? desensitizePhone(userInfo.userName) : '**** **** ****' }}</h3>
            <!--            <van-tag color="#D4AF37" text-color="#000" size="mini">钻石VIP</van-tag>-->
          </div>
          <van-button type="primary" size="mini">注册{{userInfo.registerDay || 0}}天</van-button>
        </div>
<!--        <span>{{userInfo.signature}}</span>-->
<!--        <div class="stats">-->
<!--          <div class="stat-item">-->
<!--            <p class="value">0</p>-->
<!--            <p class="label">可用积分</p>-->
<!--          </div>-->
<!--          <div class="stat-item" @click="onChangeSearch('/app_benefits')">-->
<!--            <p class="value">2</p>-->
<!--            <p class="label">可用权益</p>-->
<!--          </div>-->
<!--        </div>-->
      </template>
    </van-card>

    <!-- 球杆激活按钮 -->
    <van-button v-if="userType === '01'" class="club-activate-btn" block @click="onChangeSearch('/app_activation')">球杆绑定</van-button>

    <!--   普通会员   -->
    <div class="func-grid" v-if="userType === '01'">
      <div class="grid-item-search grid-item-left" @click="onChangeSearch('/app_search')">
        <span class="grid-text">真伪查询</span>
      </div>
      <div class="grid-item-myclub grid-item-right" @click="onChangeSearch('/app_myClub')">
        <span class="grid-text">我的球杆</span>
      </div>
      <div class="grid-item-register grid-item-left" @click="onChangeSearch('/app_after')">
        <span class="grid-text">售后申请</span>
      </div>
      <div class="grid-item-step grid-item-right" @click="onChangeSearch('/app_step')">
        <span class="grid-text">售后进度</span>
      </div>
    </div>
    <!--   代理商   -->
    <div class="func-grid" v-if="userType === '02'">
      <div class="grid-item-search grid-item-left" @click="onChangeSearch('/app_search_dls')">
        <span class="grid-text">真伪查询</span>
      </div>
      <div class="grid-item-step grid-item-right" @click="onChangeSearch('/unbind')">
        <span class="grid-text">球杆解绑</span>
      </div>
    </div>
    </div>
  </div>
</template>


<script>
import '@/assets/css/mobileGlobal.scss';
import {memberInformation} from "@/api/mine";
import {Dialog} from "vant";
import defaultAvatar from "@/assets/img/h5/avatar-default.png";
export default {
  name: 'UserInfoCard',
  data() {
    return {
      defaultAvatar: defaultAvatar,
      // topPicSrc: require("@/assets/img/company/chairman.png"),
      userInfo:{},
      avatarPic:'',
      userType: '', //用户类别：01-会员、02-代理商、00-后台用户
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    // 手机号脱敏处理
    desensitizePhone(phone) {
      if (!phone || phone.length !== 11) return phone;
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    //跳转
    onChangeSearch(path) {
      this.$router.push(path);
    },
    // 获取用户信息回显（
    async getUserInfo() {
      try {
        const res = await memberInformation();
        if (res.code === 200 && res.data) {
          // 回显用户信息
          this.userInfo =res.data;

          this.userType = res.data.userType;
          if (this.userInfo && this.userInfo.avatar) {
            this.avatarPic = this.userInfo.avatar.url ||defaultAvatar;
          }else{
            this.avatarPic =defaultAvatar;
          }
        } else if(res.code !== 401){
          Dialog.alert({ title: "提示", message: res.returnMsg });
        }
      } catch (err) {
        Dialog.alert({ title: "错误", message: "请稍后重试" });
      }
    },
  },
};
</script>

<style scoped lang="scss">
$gold: #D4AF37;
$dark-bg: #1A1A1A;
$gutter: 30px; // 四宫格间距，可统一调整

::v-deep .van-image__img{
  object-fit: cover;
}
::v-deep .van-card{
  @media (min-width: 768px) {
    padding: 20px 80px;
  }
}
::v-deep .van-card__content{
  min-height:0;
}
.h5-container {
  background: $dark-bg;
  min-height: 100vh;
}
.top-bar{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);;
}
.container-item {
  padding: 0 16px;
}

.user-card {
  margin: 16px 0;
  border-radius: 12px;
  background: linear-gradient(135deg, #222 0%, #000 100%);
  color: #fff;
  @media (min-width: 768px) {
    border-radius: 12px;
    margin: 16px 0;
  }

}
.user-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px;
  @media (min-width: 768px) {
    margin: auto 0;
  }
  h3 {
    margin: 0 0 4px 0;
    font-size: 14px;
    color: #fff;
    @media (min-width: 768px) {
      font-size: 24px;
    }
  }
}
.user-header-img{
  width: 48px;
  height: 48px;
  @media (min-width: 768px) {
    width: 100px;
    height: 100px;
  }
}
::v-deep .van-button{
  @media (min-width: 768px) {
    height: 60px;
    font-size: 24px;
  }
}
.user-info {
  flex: 1;
  margin: 0 12px;
}
.stats {
  display: flex;
  justify-content: space-around;
  padding-top: 16px;
  border-top: 1px solid rgba($gold, 0.2);
  .stat-item {
    text-align: center;
    .value {
      margin: 0;
      font-size: 16px;
      color: $gold;
    }
    .label {
      margin: 0;
      font-size: 12px;
      color: #fff;
    }
  }
}

.club-activate-btn {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  color: #000;
  font-size: 16px;
  font-weight: bold;
  border: none;
  margin-bottom: 16px;
  @media (min-width: 768px) {
    border-radius: 8px;
    height: 55px;
    font-size: 24px;
    margin-bottom: 30px;
    margin-top: 30px;
  }
}

// 四宫格容器样式 - 仅添加负边距修复布局偏移
.func-grid {
  display: flex;
  flex-wrap: wrap;
  margin: 16px 0;
  @media (min-width: 768px) {
    margin: 40px 0;
  }
}

// 四宫格每个格子样式 - 完全保留你的原始代码
.grid-item-search {
  // 2列布局，宽度50%，减去间距
  width: calc(50% - $gutter/2);
  height: 95px;
  border-radius: 10px;
  background: url('~@/assets/img/h5/home_search.png') center no-repeat;
  background-size: cover, contain; // 渐变覆盖整个格子，背景图完整显示
  // 内容居中
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    border-radius: 10px;
    height: 200px;
  }
}
.grid-item-myclub{
  width: calc(50% - $gutter/2);
  height: 95px;
  border-radius: 10px;
  background: url('~@/assets/img/h5/myclub.png') center no-repeat;
  background-size: cover, contain; // 渐变覆盖整个格子，背景图完整显示
  // 内容居中
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    border-radius: 10px;
    height: 200px;
  }
}
.grid-item-step{
  width: calc(50% - $gutter/2);
  height: 95px;
  border-radius: 10px;
  background: url('~@/assets/img/h5/step.png') center no-repeat;
  background-size: cover, contain; // 渐变覆盖整个格子，背景图完整显示
  // 内容居中
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    border-radius: 10px;
    height: 200px;
  }
}
.grid-item-register{
  width: calc(50% - $gutter/2);
  height: 95px;
  border-radius: 10px;
  background: url('~@/assets/img/h5/register.png') center no-repeat;
  background-size: cover, contain; // 渐变覆盖整个格子，背景图完整显示
  // 内容居中
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    border-radius: 10px;
    height: 200px;
  }
}
.grid-item-left{
  margin: 0 $gutter/2 $gutter/2 0;
}
.grid-item-right{
  margin: 0 0 $gutter/2 $gutter/2;
}

// 格子图标样式（保留你的原始代码，即使未使用）
.grid-icon {
  color: $gold;
  font-size: 24px;
  margin-bottom: 6px;
}

// 格子文字样式（保留你的原始代码）
.grid-text {
  color: #fff;
  font-size: 14px;
  @media (min-width: 768px) {
    font-size: 24px;
  }
}
</style>